
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tabulka",
      function () {
        return require("private-next-pages/tabulka/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tabulka"])
      });
    }
  